import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'Id',
      key: 'id',
      sortable: false
    },
    {
      label: 'bosch.panel',
      key: 'panel_name',
      sortable: false
    },
    {
      label: 'bosch.description',
      key: 'description',
      sortable: false
    },
    {
      label: 'bosch.deviceType',
      key: 'device_type',
      sortable: false
    },
    {
      label: 'bosch.deviceId',
      key: 'device_id',
      sortable: false
    },
    {
      label: 'bosch.deviceName',
      key: 'device_name',
      sortable: false
    },
    {
      label: 'bosch.areaId',
      key: 'area_id',
      sortable: false
    },
    {
      label: 'bosch.area',
      key: 'area_name',
      sortable: false
    },
    {
      label: 'bosch.eventType',
      key: 'description',
      sortable: false
    },
    {
      label: 'bosch.userId',
      key: 'user_id',
      sortable: false
    },
    {
      label: 'bosch.username',
      key: 'user_name',
      sortable: false
    },
    {
      label: 'bosch.alarmId',
      key: 'id_alarm',
      sortable: false
    },
    {
      label: 'bosch.eventDate',
      key: 'event_created_at',
      sortable: false
    }
  ]

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)
  const idPanel = router.currentRoute.params.id_panel;

  // Dispatch para obtener las opciones de filtros
  store.dispatch('bosch_panels/getAll')

  const panelOptions = computed(() => store.getters['bosch_panels/getSelectedItems'])

  const idBoschProfile = ref(parseInt(router.currentRoute.params.id_bosch_panel_profile))
  const panelFilter = ref(null)
  const startDatetimeFilter = ref(null)
  const endDatetimeFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.$refs.refTable.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('bosch_logs/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_bosch_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.$refs.refTable.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      id_bosch_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value
    }

    refetchData()
  }

  const clearSearchFilters = () => {
    panelFilter.value = null;
    startDatetimeFilter.value = null;
    endDatetimeFilter.value = null;

    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    idPanel,
    panelFilter,
    panelOptions,
    startDatetimeFilter,
    endDatetimeFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,

    idBoschProfile
  }
}
